//中文资源
import zhMessageElement from 'element-ui/lib/locale/lang/zh-CN'
import zhMessageComponent from '../components/locale/lang/zh-CN'
import zhMessageModule from '../module/locale/lang/zh-CN'

//英文资源
// import enMessageElement from 'element-ui/lib/locale/lang/en'
// import enMessageComponent from '../components/locale/lang/en'
// import enMessageModule from '../module/locale/lang/en'


//设置需要支持的语言种类
export const locales = [
    {
        value: 'zh-CN',
        name: 'Chinese',
        native: '简体中文',
    },
    {
        value: 'en-US',
        name: 'English',
        native: 'English',
    }
]

//翻译的文字
export const messages = {
    "zh-CN": {
        ...zhMessageElement,
        ...zhMessageComponent,
        ...zhMessageModule
    },
    // "en-US": {
    //     ...enMessageElement,
    //     ...enMessageComponent,
    //     ...enMessageModule
    // },
}


// WEBPACK FOOTER //
// ./src/config/i18n-map.js